import { render, staticRenderFns } from "./EmailCollection.vue?vue&type=template&id=33b23cd6&scoped=true&"
import script from "./EmailCollection.vue?vue&type=script&lang=js&"
export * from "./EmailCollection.vue?vue&type=script&lang=js&"
import style0 from "./EmailCollection.vue?vue&type=style&index=0&id=33b23cd6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b23cd6",
  null
  
)

export default component.exports